// @flow

import ApiError from '../../entities/ApiError';
import I18n from '../../i18n/I18n';

import ApiErrorUtils from '../ApiErrorUtils';

export default class KioskApiErrors {

  static put(apiError: ApiError): string {
    const errors = {
    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'KioskApiErrors:put');
  };

  static get(apiError: ApiError): string {
    const errors = {
      '102': 'Error while saving background image',
    };

    return ApiErrorUtils.findErrorOnArray(apiError, errors, 'KioskApiErrors:get');
  };
}
